import { CassetteTapeIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const FileAudio = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <CassetteTapeIcon {...rest} size={Sizes[size]} color={fill} />;
};

FileAudio.displayName = 'FileAudio';
